export enum Roles {
    ADMIN = 'ADMIN',
    CONSULTA = 'CONSULTA',
    CONCILIACION = 'CONCILIACION',
    MEDIDA = 'MEDIDA',
    PREVISION = 'PREVISION',
}
